import { Component } from "react";
import { connect } from "react-redux";
import AnalyseRisquesForm from "./AnalyseRisquesForm";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

class CreateAnalyseRisques extends Component {
    constructor(props) {
        super(props);

        if (!props.analysesRisques.editionState.creationMode) {
            if (props.location.pathname.includes("/pps")) props.history.push("/pps");
            else props.history.push("/analyseRisques");
        }
    }

    render() {
        return <AnalyseRisquesForm />;
    }
}

const mapStateToProps = (state) => {
    return {
        analysesRisques: state.analysesRisques,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CreateAnalyseRisques);
